import { useEffect, useState } from "react";
import { CustomButton } from "./CustomButton";
import { IntegrationInfo, Mismatch } from "../../types/apiTypes";
import { Box, CircularProgress } from "@mui/material";
import { useAppSelector, useStateWithSearchParams } from "hooks";
import { ResyncDataModal } from "./modal";

type Props = {
  isDisabled: boolean;
  crmIntegration?: IntegrationInfo;
  mismatches: Mismatch;
  campaign_id: string;
};

export const ResyncDataBtn = ({
  isDisabled,
  crmIntegration,
  mismatches,
  campaign_id,
}: Props) => {
  const { mismatchData } = useAppSelector((state) => state.company);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [currentMismatch, setCurrentMismatch] = useState<Mismatch>(mismatches);
  const [isLoading, setIsLoading] = useState<boolean>(mismatches.is_syncing);

  const { searchDict } = useStateWithSearchParams<{
    crm?: string;
    actionType?: string;
  }>({
    crm: undefined,
    actionType: undefined,
  });

  useEffect(() => {
    if (searchDict.crm && searchDict.actionType === "re-sync") {
      setIsOpen(true);
    }
  }, [searchDict]);

  useEffect(() => {
    setCurrentMismatch(mismatches);
  }, [mismatches]);

  useEffect(() => {
    setIsLoading(currentMismatch.is_syncing);
  }, [currentMismatch]);

  useEffect(() => {
    if (mismatchData?.campaign_id === campaign_id) {
      setCurrentMismatch(mismatchData.mismatches);
    }
  }, [mismatchData]);

  return (
    <>
      <CustomButton
        onClick={() => setIsOpen(true)}
        customSize="fit"
        customColor="#1C3C6C"
        sx={{ height: "42px", position: "relative" }}
        startIcon={
          isLoading && <CircularProgress size={20} sx={{ color: "#757575" }} />
        }
        disabled={isLoading || isDisabled}
      >
        Re-Sync Data
        {currentMismatch.total > 0 && (
          <Box
            component="span"
            style={{
              opacity: isLoading || isDisabled ? 0.6 : 1,
              position: "absolute",
              right: -8,
              top: -8,
              minWidth: "20px",
              height: "20px",
              borderRadius: "10px",
              border: "3px solid #F5F5F5",
              backgroundColor: "#E50505",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "11px",
              lineHeight: "11px",
              fontWeight: 500,
              padding: "2px",
              color: "white",
            }}
          >
            {currentMismatch.total}
          </Box>
        )}
      </CustomButton>

      <ResyncDataModal
        mismatches={currentMismatch}
        integration={crmIntegration}
        campaign_id={campaign_id}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </>
  );
};
